import {styled} from 'styled-components';

interface ScoreProps {
  value: number;
}

export function getScoreInfo(score: number): {label: string; color: string} {
  /* eslint-disable @typescript-eslint/no-magic-numbers */
  if (score < 25) {
    return {label: 'Non !', color: '#881414'};
  } else if (score < 50) {
    return {label: 'Bof', color: '#a56333'};
  } else if (score < 75) {
    return {label: 'OK', color: '#748814'};
  }
  return {label: 'Oui !', color: '#009200'};
  /* eslint-enable @typescript-eslint/no-magic-numbers */
}

export const Score: React.FC<ScoreProps> = props => {
  const {value} = props;

  const {label, color} = getScoreInfo(value);

  return <Wrapper $color={color}>{label}</Wrapper>;
};
Score.displayName = 'Score';

const Wrapper = styled.div<{$color: string}>`
  background-color: ${p => p.$color};
  color: white;
  border-radius: 4px;
  padding: 1% 3%;
  text-align: center;
`;
